const BACKEND_URL_MAP = {
  "dev.non-prod.my.thoughtworks.net":
    "https://api.oneprofile-hardware-util.non-prod-pac.thoughtworks.net/development",
  "stage.non-prod.my.thoughtworks.net":
    "https://api.oneprofile-hardware-util.non-prod-pac.thoughtworks.net/stage",
  "my.thoughtworks.net":
    "https://api.oneprofile-hardware-util.pac.thoughtworks.net/prod",
};

const currentInstance = window.location.hostname;
export function getBackendApiUrlForCurrentInstance() {
  return BACKEND_URL_MAP[currentInstance];
}

export function getEnvironment() {
  const configEnvMap = {
    "dev.non-prod.my.thoughtworks.net": "dev",
    "stage.non-prod.my.thoughtworks.net": "pre-prod",
    "my.thoughtworks.net": "prod",
  };

  const currentInstance = window.location.hostname;
  return configEnvMap[currentInstance];
}
